import React, { useEffect, useState } from 'react';
import {
    Button,
    Checkbox,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    useMediaQuery,
    Grid,
    useTheme,
    Tooltip
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Close, Visibility } from '@mui/icons-material';
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { URLS } from '../../../apis/urls';
import BottomDrawer from '../../Survey/components/BottomDrawer';
import { dossiersActions } from '../../../_actions/dossiers.actions';
import Hidden from '../../../components/Hidden';
import ExistingRepairRequestImages from './ExistingRepairRequestImages';


const ExistingImageModal = ({ closeUploadDialog, isAssignmentFile, isFundering = false, images, canDrawingDossier, existingImageModal, bottomDrawer, bottomDrawerClose, isSurveying, open, handleClose, isSingle, handlePreviewOfFiles, onselect = () => 0, ...props }) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const theme = useTheme();
	const [selectedImages, setSelectedImages] = useState([]);
	const matchWidthUpxs = useMediaQuery(theme.breakpoints.down('sm'));
	const [filterImage, setFilterImage] = useState([])
	const dispatch = useDispatch();
	const {  dossier: { imagesFromRepairRequest }, surveying: { selectedAssignment } } = useSelector(state => state);

	useEffect(() => {
		if (canDrawingDossier) {
			const pdf = images && images.filter(p => p.extension === '.pdf')
			setFilterImage(pdf)
		} else {
			setFilterImage(images)
		}
	}, [images])

	const toggleDrawerOpen = (event, data) => {
		event.stopPropagation();
		if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
			return;
		}
	};

	useEffect(() => {
		if (existingImageModal && selectedAssignment)
			dispatch(dossiersActions.getImagesFromRepairRequest(selectedAssignment.projectId, !isFundering ? selectedAssignment.buildingId : null));
	}, [existingImageModal])
                                                                              
	const handleSelect = (isAll, file) => {
		let imagesData = Object.assign([], selectedImages);
		if (!isAll && !isSingle) {
			const isExistIndex = imagesData.findIndex(image => image.fileId === file.fileId);
			isExistIndex >= 0 ? imagesData.splice(isExistIndex, 1) : imagesData.push(file)
		} else if (isSingle) {
			imagesData = imagesData.find(f => f.fileId === file.fileId) ? [] : [file];
		} else if (!isSingle && isAll)
			imagesData = imagesData.length ? [] : [...file];
		setSelectedImages(imagesData)
	}

	return <>
		<Hidden smUp>
			<BottomDrawer toggler={toggleDrawerOpen} open={bottomDrawer} close={bottomDrawerClose}>
				<div>
					<ExistingRepairRequestImages
						data={imagesFromRepairRequest ? imagesFromRepairRequest?.wbRepairRequests || [] : []}
						bottomDrawerClose={bottomDrawerClose}
						closeUploadDialog={closeUploadDialog}
						onselect={onselect}
						prefix={'EXISTING_REPAIR_REQUEST_FILES'}
						title={t('repairRequests.wkbRepairRequests')}
					/>
					<ExistingRepairRequestImages
						bottomDrawerClose={bottomDrawerClose}
						closeUploadDialog={closeUploadDialog}
						onselect={onselect}
						data={imagesFromRepairRequest ? imagesFromRepairRequest?.repairRequests || [] : []}
						prefix={'EXISTING_WKB_REPAIR_REQUEST_FILES'}
						title={t('general.repairRequests')}
					/>
				</div>
			</BottomDrawer>
		</Hidden>

        <Dialog maxWidth='md' PaperProps={{ style: { width: 'auto' } }} onClose={handleClose}
            className={existingImageModal ? classes.requestContainer : ''} aria-labelledby="images-dialog-title"
            open={matchWidthUpxs && existingImageModal ? false : open} >
            {!existingImageModal ?
                <>
                    <DialogTitle id="images-dialog-title" className={classes.titleContainer}>
                        <Container className={classes.title}>
                            {!isSingle && <>
                                <Checkbox
                                    color="primary"
                                    indeterminate={(filterImage.length && selectedImages.length !== filterImage.length) && selectedImages.length}
                                    checked={filterImage.length && selectedImages.length === filterImage.length}
                                    onChange={() => handleSelect(true, filterImage)}
                                />
                                <Typography variant={'p'} className={classes.totalImagesData}>{`(${selectedImages.length}/${filterImage.length})`}</Typography>
                            </>
                            }
                            <Typography variant={'h5'} className={classes.totalImagesHeading}>{t('files.modal.heading.title')}</Typography>
                            <IconButton onClick={handleClose} aria-label="close" size="large">
                                <Close />
                            </IconButton>
                        </Container>
                    </DialogTitle>
                    <DialogContent className={classes.container}>
                        <Grid className={classes.dialogWidthController}>
                            <Grid container spacing={1}>
                                {
                                    filterImage && filterImage.map((image, index) => {
                                        // if (canDrawingDossier && image.extension !== '.pdf') return null;
                                        const isSelected = selectedImages.some(f => f.fileId === image.fileId);
                                        return (
                                            (<Grid
                                                key={index}
                                                className={classes.fileContainer}
                                                sx={{
                                                        justifyContent: 'center'
                                                    }}>
                                                <Tooltip title={image.name}>
                                                    <Grid className={classes.thumnailContainer}>
                                                        <div className={classes.overlay}>
                                                            <IconButton
                                                                onClick={() => handlePreviewOfFiles([image])}
                                                                style={{ outline: 'none' }}
                                                                aria-label="image-preview"
                                                                size="large">
                                                                <Visibility className={classes.imagePreviewIcon} />
                                                            </IconButton>
                                                            {!isSelected && <Checkbox checked={isSelected}
                                                                onChange={() => handleSelect(false, image)} color="primary"
                                                                className={classes.checkBox}
                                                                style={{ color: 'white' }} />}
                                                        </div>
                                                        {isSelected && <Checkbox checked={isSelected}
                                                            onChange={() => handleSelect(false, image)} color="primary"
                                                            className={classes.checkBox}
                                                            style={{ color: 'white' }} />}
                                                        {isSelected && <Checkbox checked={isSelected}
                                                            onChange={() => handleSelect(false, image)} color="primary"
                                                            className={classes.checkBox}
                                                            style={{ zIndex: 5 }} />}
                                                        <div className={classes.thumbnail}
                                                            style={{ backgroundImage: `url(${URLS.GET_ATTACHMENT_THUMBNAIL}${image.fileId})` }}>{ }</div>
                                                        <Typography variant="caption" className={classes.caption} noWrap>{image.name}</Typography>
                                                    </Grid>
                                                </Tooltip>
                                            </Grid>)
                                        );
                                    })}
                            </Grid>
                        </Grid>
                    </DialogContent>
                </>
                :
                <>
                    <DialogTitle id="images-dialog-title" className={classes.dialogTitle}>
                        <Grid className={classes.dialogTitleContent} container spacing={1}>
                            <Grid className={classes.grow}>
                                <Typography variant="h5" className={classes.dialogTitleTypo}>{t('')}</Typography>
                            </Grid>
                            <Grid>
                                <IconButton
                                    onClick={handleClose}
                                    className={classes.closeButton}
                                    color="inherit"
                                    aria-label="close"
                                    size="large">
                                    <Close className={classes.iconStyle} />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent sx={{p:0}}>
                        <Grid >
							<Grid container spacing={0} >
								<ExistingRepairRequestImages
									bottomDrawerClose={bottomDrawerClose}
									closeUploadDialog={closeUploadDialog}
									onselect={onselect}
									prefix={'EXISTING_REPAIR_REQUEST_FILES'}
									data={imagesFromRepairRequest ? imagesFromRepairRequest?.wbRepairRequests || [] : []}
									title={t('repairRequests.wkbRepairRequests')}
								/>
								<ExistingRepairRequestImages
									bottomDrawerClose={bottomDrawerClose}
									closeUploadDialog={closeUploadDialog}
									onselect={onselect}
									prefix={'EXISTING_WKB_REPAIR_REQUEST_FILES'}
									data={imagesFromRepairRequest ? imagesFromRepairRequest?.repairRequests || [] : []}
						            title={t('general.repairRequests')}
								/>								
                            </Grid>
                        </Grid>
                    </DialogContent>
                </>
            }
            {!!selectedImages.length && <DialogActions>
                <Button color="primary" onClick={() => {
                    onselect(selectedImages);
                    handleClose();
                }}>
                    {t('files.button.select.title')}
                </Button>
            </DialogActions>}
        </Dialog>
        
    </>;
}

const useStyles = makeStyles((theme) => ({
	avatar: {
		width: theme.spacing(9),
		height: theme.spacing(9),
	},
	customColumnItemStyle: {
		flexGrow: 1,
		paddingLeft: theme.spacing(.5),
		fontSize: 10,
		marginBottom: 14,
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
	},
	requestSubTitle: {
		fontSize: 10,
		fontWeight: 'bold',
		color: theme.palette.common.black,
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		marginBottom: 4
	},
	requestSubTitlePrimary: {
		color: theme.palette.primary.main,
		fontWeight: 'bold'
	},
	requestContainer: {
		'& .MuiDialog-paper': {
			borderRadius: 10,
			minWidth: '70%',
			minHeight: '70%',
			[theme.breakpoints.down('md')]: {
				minWidth: '95%',
				minHeight: '70%',
			},
		},
	},
	dialogTitleContent: {
		padding: theme.spacing(1.25),
	},
	grow: {
		flexGrow: 1
	},
	dialogTitleTypo: {
		color: 'white',
		fontSize: 14,
		fontWeight: 'bold'
	},
	closeButton: {
		margin: 0,
		padding: theme.spacing(0)
	},
	iconStyle: {
		fill: 'white',
		width: '1em',
		height: '1em',
	},
	container: {
		padding: theme.spacing(0, 1.5),
	},
	dialogWidthController: {
		maxWidth: 888,
		width: 'max-content',
		[theme.breakpoints.down('lg')]: {
			maxWidth: 760,
		},
		[theme.breakpoints.down('md')]: {
			maxWidth: 504,
		},
		[theme.breakpoints.down('sm')]: {
			maxWidth: 248,
			margin: 'auto',
		},
	},
	totalImagesData: {
		lineHeight: 1.334,
		[theme.breakpoints.down('sm')]: {
			fontSize: '1rem',
		},
		[theme.breakpoints.down(360)]: {
			fontSize: '0.9rem',
		}
	},
	totalImagesHeading: {
		flexGrow: 1,
		whiteSpace: 'nowrap',
		[theme.breakpoints.down('sm')]: {
			fontSize: '1rem',
		},
		[theme.breakpoints.down(360)]: {
			fontSize: '0.9rem',
		},

	},
	dialogTitle: {
		padding: theme.spacing(.625),
		background: theme.palette.primary.main,
		'& .MuiIconButton-label > .MuiSvgIcon-root': {
			fill: theme.palette.grey[300]
		},
	},
	titleContainer: {
		padding: theme.spacing(1, 2),
		[theme.breakpoints.down('sm')]: {
			padding: theme.spacing(1, 0),
		}
	},
	title: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: 0
	},
	caption: {
		width: '100%',
		textAlign: 'center'
	},
	thumbnail: {
		backgroundPosition: 'center',
		backgroundSize: 'contain',
		backgroundRepeat: 'no-repeat',
		height: 80,
		padding: '35% 0',
		width: '100%',
	},
	checkBox: {
		position: 'absolute',
		right: 0,
		top: 0,
		padding: 0
	},
	imagePreviewIcon: {
		fill: theme.palette.common.white,
		width: '1.5em',
		height: '1.5em'
	},
	overlay: {
		position: 'absolute',
		background: 'rgba(0, 0, 0, 0.5)', /* Black see-through */
		width: '100%',
		transition: '.5s ease',
		opacity: 0,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 2,
		height: '100%',
	},
	fileContainer: {
		display: 'flex',
	},
	thumnailContainer: {
		minHeight: 100,
		display: 'flex',
		height: 120,
		width: 120,
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		position: 'relative',
		cursor: 'pointer',
		'&:hover': {
			"& $overlay": {
				opacity: 1
			},
		},
	}
}));
export default ExistingImageModal;
